import { AutoComplete } from 'antd';
import { useQuery } from '@tanstack/react-query';
import { lookupsApi } from '../../api/endpoints/lookups';

interface LookupAutoCompleteProps {
  /** Nombre del catálogo, ej. 'account_business1'. */
  listName: string;
  value?: string;
  onChange?: (value: string) => void;
  placeholder?: string;
  style?: React.CSSProperties;
}

/**
 * Input con sugerencias de un catálogo (Lookup) que **sigue permitiendo
 * texto libre** — no rompe valores ya capturados que no estén en el catálogo.
 * Guarda la etiqueta legible (label) como valor del campo.
 */
export function LookupAutoComplete({
  listName,
  value,
  onChange,
  placeholder,
  style,
}: LookupAutoCompleteProps): JSX.Element {
  const { data } = useQuery({
    queryKey: ['lookups', listName],
    queryFn: () => lookupsApi.byList(listName),
    staleTime: 5 * 60_000,
  });

  const options = (data ?? []).map((l) => ({ value: l.label }));

  return (
    <AutoComplete
      allowClear
      value={value}
      onChange={(v) => onChange?.(v ?? '')}
      options={options}
      placeholder={placeholder}
      style={{ width: '100%', ...style }}
      filterOption={(input, option) =>
        (option?.value ?? '').toLowerCase().includes(input.toLowerCase())
      }
    />
  );
}
